import { render, staticRenderFns } from "./PackageDetailsForm.vue?vue&type=template&id=7ee294b5&"
import script from "./PackageDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PackageDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports